import script from "./TaskTeaser.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskTeaser.vue?vue&type=script&setup=true&lang=js"

import "./TaskTeaser.vue?vue&type=style&index=0&id=41c17c66&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c17c66"]])

export default __exports__